import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  GoogleMap,
  LoadScript,
  useJsApiLoader,
  Marker,
  InfoWindow
} from '@react-google-maps/api';
import routeslogo from './assets/routeslogo.png';
// import shuttleIconImg from './assets/shuttle_icon.png';
// import shuttleIconLeftToRightImg from './assets/shuttle_icon.png';
// import shuttleIconRightToLeftImg from './assets/shuttle_icon_right_to_left.png';
// import shuttleIconTopToBottomImg from './assets/shuttle_icon_top_to_bottom.png';
// import shuttleIconBottomToTopImg from './assets/shuttle_icon_bottom_to_top.png';
import shuttleIconImg from './assets/left_to_right.png';
import shuttleIconLeftToRightImg from './assets/left_to_right.png';
import shuttleIconRightToLeftImg from './assets/right_to_left.png';
import shuttleIconTopToBottomImg from './assets/top_to_down.png';
import shuttleIconBottomToTopImg from './assets/down_to_top.png';
import PillarIconImg from './assets/shuttle_stop_icon.png';
import locationIconImg from './assets/my_location_icon.png';
import destinationIconImg from './assets/destination_location_icon.png';
import { baseURL } from './backend_url';
import "./Dashboard.css"
import axios from 'axios';
import Select from "react-select";
import Swal from "sweetalert2";
import ReactDOMServer from 'react-dom/server'; // Import ReactDOMServer


// Left to Right
// const CurvedArrowHeadLeftToRight = () => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
//       {/* Curved arrowhead */}
//       <path 
//         className="blinking"
//         d="M 15 10 Q 30 25 15 40 L 45 25 Z"
//         fill="blue" 
//       />

//       <style>{`
//         .blinking {
//           animation: blink 1.5s infinite;
//         }

//         @keyframes blink {
//           0% { opacity: 1; }
//           50% { opacity: 0.2; }
//           100% { opacity: 1; }
//         }
//       `}</style>
//     </svg>
//   );
// }

const CurvedArrowHeadLeftToRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60" height="60">
      {/* Multiple circles for a ripple effect */}
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />

      {/* Larger curved arrowhead pointing left to right */}
      <path 
        d="M 15 15 Q 30 30 15 45 L 45 30 Z"
        fill="blue" 
      />

      <style>{`
        .wave-circle {
          stroke-width: 2;
          opacity: 0;
          animation: ripple 2.5s ease-out infinite;
        }

        .wave-circle:nth-child(1) {
          animation-delay: 0s;
        }
        
        .wave-circle:nth-child(2) {
          animation-delay: 0.5s;
        }
        
        .wave-circle:nth-child(3) {
          animation-delay: 1s;
        }

        @keyframes ripple {
          0% {
            r: 0;
            opacity: 1;
          }
          50% {
            r: 20;
            opacity: 0.6;
          }
          100% {
            r: 28;
            opacity: 0;
          }
        }
      `}</style>
    </svg>
  );
}


// const CurvedArrowHeadRightToLeft = () => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
//       {/* Curved arrowhead pointing right to left */}
//       <path 
//         className="blinking"
//         d="M 45 10 Q 30 25 45 40 L 15 25 Z"
//         fill="blue" 
//       />

//       <style>{`
//         .blinking {
//           animation: blink 1.5s infinite;
//         }

//         @keyframes blink {
//           0% { opacity: 1; }
//           50% { opacity: 0.2; }
//           100% { opacity: 1; }
//         }
//       `}</style>
//     </svg>
//   );
// }



// Wave
const CurvedArrowHeadRightToLeft = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60" height="60">
      {/* Multiple circles for a ripple effect */}
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />

      {/* Larger curved arrowhead pointing right to left */}
      <path 
        d="M 45 15 Q 30 30 45 45 L 15 30 Z"
        fill="blue" 
      />

      <style>{`
        .wave-circle {
          stroke-width: 2;
          opacity: 0;
          animation: ripple 2.5s ease-out infinite;
        }

        .wave-circle:nth-child(1) {
          animation-delay: 0s;
        }
        
        .wave-circle:nth-child(2) {
          animation-delay: 0.5s;
        }
        
        .wave-circle:nth-child(3) {
          animation-delay: 1s;
        }

        @keyframes ripple {
          0% {
            r: 0;
            opacity: 1;
          }
          50% {
            r: 20;
            opacity: 0.6;
          }
          100% {
            r: 28;
            opacity: 0;
          }
        }
      `}</style>
    </svg>
  );
}





// const CurvedArrowHeadUpToDown = () => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
//       {/* Curved arrowhead pointing up to down */}
//       <path 
//         className="blinking"
//         d="M 10 15 Q 25 30 40 15 L 25 45 Z"
//         fill="blue" 
//       />

//       <style>{`
//         .blinking {
//           animation: blink 1.5s infinite;
//         }

//         @keyframes blink {
//           0% { opacity: 1; }
//           50% { opacity: 0.2; }
//           100% { opacity: 1; }
//         }
//       `}</style>
//     </svg>
//   );
// }

const CurvedArrowHeadUpToDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60" height="60">
      {/* Multiple circles for a ripple effect */}
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />

      {/* Curved arrowhead pointing up to down */}
      <path 
        d="M 10 15 Q 25 30 40 15 L 25 45 Z"
        fill="blue" 
      />

      <style>{`
        .wave-circle {
          stroke-width: 2;
          opacity: 0;
          animation: ripple 2.5s ease-out infinite;
        }

        .wave-circle:nth-child(1) {
          animation-delay: 0s;
        }
        
        .wave-circle:nth-child(2) {
          animation-delay: 0.5s;
        }
        
        .wave-circle:nth-child(3) {
          animation-delay: 1s;
        }

        @keyframes ripple {
          0% {
            r: 0;
            opacity: 1;
          }
          50% {
            r: 20;
            opacity: 0.6;
          }
          100% {
            r: 28;
            opacity: 0;
          }
        }
      `}</style>
    </svg>
  );
}




// const CurvedArrowHeadDownToUp = () => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
//       {/* Curved arrowhead pointing down to up */}
//       <path 
//         className="blinking"
//         d="M 10 45 Q 25 30 40 45 L 25 15 Z"
//         fill="blue" 
//       />

//       <style>{`
//         .blinking {
//           animation: blink 1.5s infinite;
//         }

//         @keyframes blink {
//           0% { opacity: 1; }
//           50% { opacity: 0.2; }
//           100% { opacity: 1; }
//         }
//       `}</style>
//     </svg>
//   );
// }


const CurvedArrowHeadDownToUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60" height="60">
      {/* Multiple circles for a ripple effect */}
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />
      <circle
        className="wave-circle"
        cx="30"
        cy="30"
        r="0"
        stroke="lightblue"
        strokeWidth="2"
        fill="none"
      />

      {/* Curved arrowhead pointing down to up */}
      <path 
        d="M 10 45 Q 25 30 40 45 L 25 15 Z"
        fill="blue" 
      />

      <style>{`
        .wave-circle {
          stroke-width: 2;
          opacity: 0;
          animation: ripple 2.5s ease-out infinite;
        }

        .wave-circle:nth-child(1) {
          animation-delay: 0s;
        }
        
        .wave-circle:nth-child(2) {
          animation-delay: 0.5s;
        }
        
        .wave-circle:nth-child(3) {
          animation-delay: 1s;
        }

        @keyframes ripple {
          0% {
            r: 0;
            opacity: 1;
          }
          50% {
            r: 20;
            opacity: 0.6;
          }
          100% {
            r: 28;
            opacity: 0;
          }
        }
      `}</style>
    </svg>
  );
}

const getSVGDataUrl = (svg) => {
  const svgString = ReactDOMServer.renderToStaticMarkup(svg); // Convert to static markup
  const encodedData = encodeURIComponent(svgString);
  return `data:image/svg+xml;charset=utf-8,${encodedData}`;
};

const icons = {
  PillarIcon: {
    url: PillarIconImg,
    scaledSize: { width: 30, height: 40 }
  },
  locationIcon: {
    url: locationIconImg,
    scaledSize: { width: 30, height: 30 }
  },
  destinationIcon: {
    url: destinationIconImg,
    scaledSize: { width: 30, height: 30 }
  },
  shuttleIcon: {
    url: shuttleIconImg,
    scaledSize: { width: 20, height: 20 },
  },
  shuttleIconLeftToRight: {
    url: shuttleIconLeftToRightImg,
    scaledSize: { width: 20, height: 20 },
  },
  shuttleIconRightToLeft: {
    url: shuttleIconRightToLeftImg,
    scaledSize: { width: 20, height: 20 },
  },
  shuttleIconTopToBottom: {
    url: shuttleIconTopToBottomImg,
    scaledSize: { width: 20, height: 20 },
  },
  shuttleIconBottomToTop: {
    url: shuttleIconBottomToTopImg,
    scaledSize: { width: 20, height: 20 },
  },
  // shuttleIcon: {
  //   url: getSVGDataUrl(<CurvedArrowHeadLeftToRight />),
  //   scaledSize: { width: 30, height: 30 }
  // },
  // shuttleIconLeftToRight: {
  //   url: getSVGDataUrl(<CurvedArrowHeadLeftToRight />),
  //   scaledSize: { width: 30, height: 30 }
  // },
  // shuttleIconRightToLeft: {
  //   url: getSVGDataUrl(<CurvedArrowHeadRightToLeft />),
  //   scaledSize: { width: 30, height: 30 }
  // },
  // shuttleIconTopToBottom: {
  //   url: getSVGDataUrl(<CurvedArrowHeadUpToDown />),
  //   scaledSize: { width: 30, height: 30 }
  // },
  // shuttleIconBottomToTop: {
  //   url: getSVGDataUrl(<CurvedArrowHeadDownToUp />),
  //   scaledSize: { width: 30, height: 30 }
  // }
};
// Function to calculate the distance between two points
const getDistance = (point1, point2) => {
  const lat1 = point1.lat;
  const lng1 = point1.lng;
  const lat2 = point2.lat;
  const lng2 = point2.lng;
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLng = (lng2 - lng1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
};

const VehicleTracker = () => {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [vehicleLocations, setVehicleLocations] = useState([]);
  // const [mapCenter, setMapCenter] = useState({ lat: 28.4295, lng: -81.3089 }); // Default to MCO
  const [mapCenter, setMapCenter] = useState(null); // Default to MCO
  const [vehicleIcons, setVehicleIcons] = useState({}); // State to track icons for each vehicle
  const [veihcleDetail, setVehicleDetail] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [fetchInterval, setFetchInterval] = useState(null);
  const [myLocation, setMylocation] = useState({ lat: 28.4295, lng: -81.3089 });
  const [showMap, setShowMap] = useState(false); // State to toggle map display
  const [routesLocationCord, setRoutesLocationCord] = useState({ lat: 28.461710, lng: -81.273550 });
  const [allTerminal, setAllTerminal] = useState([]);
  const [errorFlag, setErrorFlag] = useState(false)
  const prevVehicleLocationsRef = useRef([]);
  const [hashPlate, setHashPlate] = useState({});
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  });

  useEffect(() => {
    if (companyName) {

      const companyIdTemp = '690337';
      setCompanyId(companyIdTemp);
      const loggedInUser = sessionStorage.getItem("user_token");
      const foundUser = JSON.parse(loggedInUser);
      setLoggedInUserDetail(foundUser); //.userEmail

      axios.get(baseURL + "/get_company_location/" + companyIdTemp)
        .then((res) => {
          axios.get(baseURL + "/srt_get_active_location/" + companyIdTemp.toString())
            .then((res1) => {
              axios.get(baseURL + "/srt_get_user_location/" + foundUser.userEmail)
                .then((res2) => {
                  const assigned_location_hash = res2.data;
                  let allTemp = res.data.res;
                  let hashLocationNameId = {};
                  allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
                  setHashLocationNameVsID(hashLocationNameId);
                  if (allTemp.length > 0) {
                    let tempArr = [];
                    for (let i = 0; i < allTemp.length; i++) {
                      if (foundUser.role === 'Users') {
                        if (res1.data[allTemp[i].location_id] === true && assigned_location_hash[allTemp[i].location_id] === true) {
                          tempArr.push(allTemp[i]);
                        }
                      }
                      else {
                        if (res1.data[allTemp[i].location_id] === true) {
                          tempArr.push(allTemp[i]);
                        }
                      }
                    }
                    setLocationDetail(tempArr);
                    setVehicleDetail([])
                    setVehicleLocations([])
                    setShowMap(false); // Reset showMap state when location changes
                    if (fetchInterval) {
                      clearInterval(fetchInterval);
                      setFetchInterval(null);
                    }
                  }
                })
            })
            .catch(error => console.error("Error fetching active locations:", error));
        })
        .catch(error => console.error("Error fetching company locations:", error));
      // }
    }
  }, []);

  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsID[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId);
  };

  useEffect(() => {
    if (locationName) {
      setVehicleDetail([]);
      setVehicleLocations([]);
      setShowMap(false); // Reset showMap state when location changes
      if (fetchInterval) {
        clearInterval(fetchInterval);
        setFetchInterval(null);
      }
      axios
        .post(`${baseURL}/srt_get_terminals_pillars`, { locationId })
        .then((response) => {
          if (response.data.status === 'success') {
            setAllTerminal(response.data.terminal_pillar);
            setRoutesLocationCord({ lat: 1 * response.data.location_cod.lat, lng: 1 * response.data.location_cod.lng }) //{lat: '28.461710', lng: '-81.273550'}
            setHashPlate(response.data.hash_srt_plate_num)
            setErrorFlag(false)
          } else {
            Swal.fire("Failed", "For this location, Terminals and Pillars data not present", "error");
            setErrorFlag(true);
          }

        })
        .catch((error) => {
          Swal.fire("Failed", "For this location, Terminals and Pillars data not present", "error");
          setErrorFlag(true);
        });
    }
  }, [locationName]);

  const fetchVehicleLocations = useCallback(() => {
    fetch(`${baseURL}/srt_vehicle_live_location/${locationId}`)
      .then(response => response.json())
      .then(data => {
        const vehicleLocArr = data.map(({ lat, lng }) => ({ lat, lng }));

        setVehicleLocations(vehicleLocArr);
        setVehicleDetail(data);
        const updatedIcons = {};

        vehicleLocArr.forEach((vehicleLoc, index) => {
          // let prevLoc = vehicleLocations[index] || vehicleLocArr[index];
          let prevLoc = prevVehicleLocationsRef.current[index] || vehicleLocArr[index];

          let icon = icons.shuttleIcon; // Default icon
          const latDiff = vehicleLoc.lat - prevLoc.lat;
          const lngDiff = vehicleLoc.lng - prevLoc.lng;

          if (Math.abs(latDiff) > Math.abs(lngDiff)) {
            icon = latDiff > 0 ? icons.shuttleIconBottomToTop : icons.shuttleIconTopToBottom;
          } else {
            icon = lngDiff > 0 ? icons.shuttleIconLeftToRight : icons.shuttleIconRightToLeft;
          }
        

          updatedIcons[index] = icon;
        });

        setVehicleIcons(updatedIcons);

        // if (vehicleLocArr.length > 0) {
        //   const nearestVehicle = vehicleLocArr.reduce((nearest, vehicle) => {
        //     const distance = getDistance(mapCenter, vehicle);
        //     return distance < nearest.distance ? { location: vehicle, distance } : nearest;
        //   }, { location: null, distance: Infinity });
        //   setMapCenter(nearestVehicle.location);
        // }
        prevVehicleLocationsRef.current = vehicleLocArr;
      })
      .catch(error => console.error("Error fetching vehicle locations:", error));
  }, [baseURL, locationId, mapCenter, vehicleLocations]);

  const handleShowButtonClick = () => {
    if (fetchInterval) {
      clearInterval(fetchInterval);
    }
    // setMapCenter(routesLocationCord)
    setShowMap(true); // Show map when button is clicked
    fetchVehicleLocations(); // Fetch immediately
    const interval = setInterval(fetchVehicleLocations, 5000);
    setFetchInterval(interval);
  };


  useEffect(() => {
    return () => {
      if (fetchInterval) {
        clearInterval(fetchInterval);
      }
    };
  }, [fetchInterval]);

  // useEffect(() => {
  //   console.log("--vehicleLocations in useEffect--", vehicleLocations);
  // }, [vehicleLocations]);

  const mapContainerStyle = {
    width: '100%',
    height: '700px'
  };


  const silverStyle = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },

    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ];



  const options = {
    // disableDefaultUI: true,
    zoomControl: true,
    styles: silverStyle,

  };
  // const mapRef = useRef(null);
  const onLoad = useCallback((map) => {
    const bounds = new window.google.maps.LatLngBounds();

    // Extend bounds for each relevant location
    bounds.extend(routesLocationCord);

    allTerminal.forEach((terminal) =>
      terminal.pillars.forEach((pillar) => {
        bounds.extend({ lat: 1 * pillar.latitude, lng: 1 * pillar.longitude });
      })
    );

    vehicleLocations.forEach((location) => {
      bounds.extend({ lat: location.lat, lng: location.lng });
    });

    // Fit map to bounds and set default center
    map.fitBounds(bounds);
    setMapCenter(bounds.getCenter().toJSON());
    // mapRef.current = map;
  }, [allTerminal, routesLocationCord,vehicleLocations]);


  return (
    <div className="container mt-5">
      <div className="p-1 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Dashboard</h4>

        {companyName && (
          <>
            <div className="mb-4">
              <label htmlFor="location_name" className="form-label">
                Select Location
              </label>
              <Select
                value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                inputId="location_name"
                name="location_name"
                options={locationDetail.map(location => ({
                  value: location.location_id,
                  label: `${location.location_name} - ${location.location_id.split('-')[1]}`
                }))}
                onChange={handleInputChangeLocationName}
              />
            </div>
            {locationName && !errorFlag && (
              <div className="mb-4 d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleShowButtonClick}>Show Live Shuttle Tracking</button>
              </div>
            )}
            <div className="mb-4">
              {showMap && locationName && (vehicleLocations.length > 0 ? (
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={mapCenter || routesLocationCord}
                  // center={{ lat: 28.4295, lng: -81.3089 }}
                  zoom={14}
                  options={options}
                  onLoad={onLoad}
                >
                  <Marker
                    position={routesLocationCord}
                    icon={icons.destinationIcon}
                    title="Routes Car Rental"
                  ><InfoWindow options={{
                    // pixelOffset: { width: 0, height: -35 },

                  }}
                    position={routesLocationCord}

                  >
                      <div>
                        <div className='d-flex justify-content-center mb-1'><img src={routeslogo} alt="Live Shuttle Tracking" style={{ width: '50px', height: 'auto' }} className="mx-auto" /></div>
                        <div className='d-flex justify-content-center'><span style={{ color: 'green' }}><b>Routes {" " + locationId.split('-')[1]}</b></span> </div>
                      </div>
                    </InfoWindow>
                  </Marker>

                  {allTerminal.length > 0 && allTerminal.map((terminal) => terminal.pillars.map((pillar, index) => (
                    <Marker
                      key={index}
                      position={{ lat: 1 * pillar.latitude, lng: 1 * pillar.longitude }}
                      icon={icons.PillarIcon}
                      title={pillar.number}
                      label={{
                        text: pillar.number, // Text for the label
                        color: "black", // Text color
                        fontWeight: "bold", // Make the text bold
                        fontSize: "14px", // Adjust font size as needed
                      }}
                    >
                      {/* <InfoWindow options={{
                        // pixelOffset: { width: 0, height: -35 },

                      }}
                        position={{ lat: 1 * pillar.latitude, lng: 1 * pillar.longitude }}

                      >
                        <div >
                          <span style={{ color: 'red' }}>{pillar.number}</span>
                        </div>
                      </InfoWindow> */}
                    </Marker>
                  )))}
                  {/* vehicle */}
                  {vehicleLocations.map((location, index) => (

                    <Marker
                      key={index}
                      position={{ lat: location.lat, lng: location.lng }}
                      icon={(vehicleIcons[index])}
                      title={`Name: ${veihcleDetail[index]['name'] || 'Unknown'}`}
                    >
                      <InfoWindow 
                      // options={{ pixelOffset: { width: 0, height: -35 } }} 
                      position={{ lat: location.lat, lng: location.lng }}>
                        <div >
                          <span style={{ color: veihcleDetail[index].engineStatus ? 'blue' : "grey" }}>Name: {veihcleDetail[index]['name']}<br /></span>
                          
                        </div>
                      </InfoWindow>
                    </Marker>
                  ))}
                </GoogleMap>) :
                (
                  <div className="text-center mt-4">
                    {/* <p>Tracking not available for this location. Please contact support@routes.ca</p> */}
                  </div>
                ))}
            </div>
          </>
        )}
      </div>
    </div >
  );
};

export default VehicleTracker;




